import { createGlobalStyle } from 'styled-components'

import CircularBook from '../assets/fonts/CircularStd-Book.woff2'
import CircularMedium from '../assets/fonts/CircularStd-Medium.woff2'
import CircularBold from '../assets/fonts/CircularStd-Bold.woff2'
import CircularBlack from '../assets/fonts/CircularStd-Black.woff2'

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'CircularStd';
    font-display: swap;
    src: url(${CircularBook}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'CircularStd';
    font-display: swap;
    src: url(${CircularMedium}) format("woff2");
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'CircularStd';
    font-display: swap;
    src: url(${CircularBold}) format("woff2");
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'CircularStd';
    font-display: swap;
    src: url(${CircularBlack}) format("woff2");
    font-weight: 900;
  }
`

// const primary = '#1A2238'
// const secondary = '#FF6A3D'
// const tertiary = '#F4DB7D'

// const primary = '#242333'
// const secondary = '#01B0D3'
// const tertiary = '#FFFFFF'

const primary = '#2d495e'
const secondary = '#e19f38'
const tertiary = '#0b1c2b'
const quaternary = '#f6dfa5'

// const primary = `black`
const accent = '#FF073A'
const success = '#20CA14'
const error = accent
const focus = '#767676'
const siteWidth = '1200px'

const variables = {
  siteWidth,
  color: {
    primary,
    accent,
    secondary,
    tertiary,
    quaternary,
    error,
    success,
    focus,
  },
  layout: {
    header_height: '70px',
    nav_width_web: '240px',
    nav_height_mobile: '64px',
    container_padding: '2rem 2rem 1rem 2rem',
    mobile_s: `@media (min-width: 320px)`,
    mobile_m: `@media (min-width: 375px)`,
    mobile_l: `@media (min-width: 425px)`,
    tablet: `@media (min-width: 768px)`,
    desktop: `@media (min-width: 1024px)`,
    desktop_l: `@media (min-width: 1440px)`,
    desktop_4k: `@media (min-width: 2560px)`
  },
}

export default variables;
